export default {
  how_to_place_order: {
    header: 'Come effettuo un ordine?',
    body: 'Sfoglia il menu, aggiungi articoli al carrello e segui i passaggi del pagamento. Riceverai una conferma a ordine effettuato.',
  },
  schedule_order: {
    header: 'Posso programmare un ordine in anticipo?',
    body: "Sì! Al momento del pagamento, scegli l'opzione «Pianifica» per impostare un orario di ritiro futuro adatto a te.",
  },
  customize_order: {
    header: 'Posso personalizzare il mio ordine?',
    body: 'Certamente. Tocca un articolo del menu per vedere le opzioni di personalizzazione, come aggiunte, contorni e preferenze.',
  },
  track_order: {
    header: 'Come monitoro il mio ordine?',
    body: "Dopo aver effettuato l'ordine, vedrai aggiornamenti in tempo reale nell'app, dalla conferma alla preparazione fino alla disponibilità per il ritiro.",
  },
  cancel_or_edit_order: {
    header: "Posso annullare o modificare l'ordine dopo averlo effettuato?",
    body: "Se il tuo ordine non è ancora in preparazione, puoi richiedere modifiche chiamando direttamente il ristorante tramite l'app.",
  },
  payment_methods: {
    header: 'Quali metodi di pagamento accettate?',
    body: 'Accettiamo le principali carte di credito/debito, Apple Pay e Google Pay, a seconda del dispositivo.',
  },
  no_confirmation: {
    header: 'Non ho ricevuto una conferma. Cosa devo fare?',
    body: "Controlla la cartella spam della tua email o visita la scheda Ordini nell'app. Se non la trovi, contatta direttamente il ristorante.",
  },
  pickup_instructions: {
    header: 'Dove ritiro il mio ordine?',
    body: "Le istruzioni per il ritiro sono indicate nella schermata di conferma e nel riepilogo dell'ordine. Cerca la segnaletica o chiedi al personale all'arrivo.",
  },
  loyalty_points: {
    header: 'Posso guadagnare punti fedeltà con i miei ordini?',
    body: "Sì, gli acquisti idonei accumulano punti automaticamente. Puoi visualizzare il saldo e i premi nella schermata principale dell'app.",
  },
  apply_promo_code: {
    header: 'Come applico un codice promo o uno sconto?',
    body: "Durante il pagamento, troverai un'opzione per inserire un codice promo. Gli sconti disponibili vengono applicati automaticamente se idonei.",
  },
  issue_with_order: {
    header: "Cosa devo fare se c'è un problema con il mio ordine?",
    body: "Siamo qui per aiutarti. Contatta il ristorante tramite l'app o il supporto via email usando l'opzione Contatta il supporto.",
  },
  use_loyalty_and_coupon: {
    header: 'Posso usare punti fedeltà e un coupon (tipo Prendi 2 Paghi 1) nello stesso ordine?',
    body: "No: per ordine può essere applicato un solo sconto o offerta. Ciò garantisce un uso equo di premi e promozioni. Scegli l'opzione più conveniente!",
  },
};
